<template>
    <div class="search__empty-result">
        <div class="search__empty-result_padding">
            {{ searchFor }} "{{ query }}"
        </div>
        {{ searchNothingWasFound }} <br>
        {{ searchTryDifferentKeyword }}
    </div>
</template>

<script lang="ts" setup>
    import { Strings } from '@/locales/types/enums';
    import { useI18n } from "vue-i18n";
    import { storeToRefs } from 'pinia';
    import { useSearchPageStore } from "@/stores/SearchPage";


    const SearchPageStore = useSearchPageStore();
    const {
        getQuery :query
    } = storeToRefs(SearchPageStore);

    const { t } = useI18n();
    const searchFor: string = t(Strings.SEARCH_SEARCH_FOR).toString();
    const searchNothingWasFound: string = t(Strings.SEARCH_NOTHING_WAS_FOUND).toString();
    const searchTryDifferentKeyword: string = t(Strings.SEARCH_TRY_DIFFERENT_KEYWORD).toString();
</script>
